const LOOPBACK_HOSTS = ['127.0.0.1', 'localhost', '[::1]']

/** True for a host (with optional port) that points back at this computer. */
export const isLoopbackHost = (host: string): boolean => LOOPBACK_HOSTS.includes(new URL(`http://${host}`).hostname)
